import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { SmartProcessingAudit } from '../../domain/entities/SmartProcessingAudit'
import { ISmartProcessingAuditRepository } from '../../domain/repositories/ISmartProcessingAudit.repository'
import { SmartProcessingAuditSchema } from '../schemas/SmartProcessingAudit.schema'
import { SmartProcessingAuditClient } from './SmartProcessingAuditClient.abstract'

/**
 * Parse tolerante: uma variavel fora do contrato (ex: variavel_de_interesse que
 * ainda nao existe no enum do front) nao pode derrubar a auditoria das outras.
 * Mesmo padrao de MonitoredAreaRepositoryApi.adapter.ts.
 */
function parseSmartProcessingAuditList(rawData: unknown): SmartProcessingAudit[] {
	if (!Array.isArray(rawData)) return []

	const items: SmartProcessingAudit[] = []
	const skipped: { index: number; variavel: unknown; issues: unknown }[] = []

	rawData.forEach((item, index) => {
		const record = item as Record<string, unknown>
		try {
			const result = SmartProcessingAuditSchema.safeParse(item)
			if (result.success) items.push(result.data)
			else
				skipped.push({
					index,
					variavel: record?.variavel_de_interesse,
					issues: result.error?.issues,
				})
		} catch (erro) {
			skipped.push({ index, variavel: record?.variavel_de_interesse, issues: erro })
		}
	})

	if (skipped.length > 0) {
		console.warn(
			`[SmartProcessingAudit] ${skipped.length} de ${rawData.length} item(s) descartado(s):`,
			skipped,
		)
	}

	return items
}

export class SmartProcessingAuditRepository implements ISmartProcessingAuditRepository {
	private readonly _endpoint = '/v1/ProcessamentoInventarioFlorestal'

	constructor(private readonly _httpClient: SmartProcessingAuditClient) {}

	async getByForestInventoryStratumId(
		forestInventoryStratumId: string,
	): Promise<SmartProcessingAudit[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-dados-auditoria-processamento-smart`,
			{ params: { idEstratoInventarioFlorestal: forestInventoryStratumId } },
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível recuperar os dados de auditoria do processamento smart. Por favor, tente novamente',
			)
		}

		return parseSmartProcessingAuditList(response.data)
	}
}
